import { render, staticRenderFns } from "./Configuracoes.vue?vue&type=template&id=322e29d9&scoped=true&"
import script from "./Configuracoes.vue?vue&type=script&lang=js&"
export * from "./Configuracoes.vue?vue&type=script&lang=js&"
import style0 from "./Configuracoes.vue?vue&type=style&index=0&id=322e29d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e29d9",
  null
  
)

export default component.exports